import { getUrlParam } from '@tencent/magic-ui-util';
import cookie from '@tencent/vft-common/cookie';

// 是否comm cgi请求
export const isCommcgiRequest = (url) => {
  const u = new URL(url);
  return u.hostname === 'vip.video.qq.com' && u.pathname === '/fcgi-bin/comm_cgi';
};

// 是否魔方请求
export const isMagicRequest = url => new URL(url).hostname === 'activity.video.qq.com';

// tv活动页
export const isTVPage = () => getUrlParam('_device') === 'tv';

export const fixUrl = url => (url.startsWith('//') ? location.protocol + url : url);


// 是否是TV扫码下来的H5页面, 加上isTVPage的否定判断，防止运营乱加参数，在tv活动面链接上也带上了tv_login_flag的情况
export const isTVH5Page = () => getUrlParam('tv_login_flag') && !isTVPage();

// 取出从cookie中取出原链接上o_开头的参数传给后端接口(在登录插件中，存入了cookie中)
export const getCookieParams = () => JSON.parse(cookie.get('_private_magic_o_params') || '{}');

// 是否请求魔方测试平台, tv活动页
export const cgitest = () => getUrlParam('cgitest');
